import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  GET_UNREAD_COUNT,
  GET_UNREAD_COUNT_SUCCESS,
  GET_UNREAD_COUNT_FAIL,
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAIL,
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_FAIL,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
  MARK_NOTIFICATION_AS_SEEN,
  MARK_NOTIFICATION_AS_SEEN_SUCCESS,
  MARK_NOTIFICATION_AS_SEEN_FAIL,
  RESET_NOTIFICATION_FLAG,
} from "./actionTypes"

// Get Notifications
export const getNotifications = () => ({
  type: GET_NOTIFICATIONS,
})

export const getNotificationsSuccess = notifications => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: notifications,
})

export const getNotificationsFail = error => ({
  type: GET_NOTIFICATIONS_FAIL,
  payload: error,
})

// Get Unread Count
export const getUnreadCount = () => ({
  type: GET_UNREAD_COUNT,
})

export const getUnreadCountSuccess = count => ({
  type: GET_UNREAD_COUNT_SUCCESS,
  payload: count,
})

export const getUnreadCountFail = error => ({
  type: GET_UNREAD_COUNT_FAIL,
  payload: error,
})

// Add Notification
export const addNotification = notification => ({
  type: ADD_NOTIFICATION,
  payload: notification,
})

export const addNotificationSuccess = notification => ({
  type: ADD_NOTIFICATION_SUCCESS,
  payload: notification,
})

export const addNotificationFail = error => ({
  type: ADD_NOTIFICATION_FAIL,
  payload: error,
})

// Update Notification
export const updateNotification = notification => ({
  type: UPDATE_NOTIFICATION,
  payload: notification,
})

export const updateNotificationSuccess = notification => ({
  type: UPDATE_NOTIFICATION_SUCCESS,
  payload: notification,
})

export const updateNotificationFail = error => ({
  type: UPDATE_NOTIFICATION_FAIL,
  payload: error,
})

// Delete Notification
export const deleteNotification = id => ({
  type: DELETE_NOTIFICATION,
  payload: id,
})

export const deleteNotificationSuccess = id => ({
  type: DELETE_NOTIFICATION_SUCCESS,
  payload: id,
})

export const deleteNotificationFail = error => ({
  type: DELETE_NOTIFICATION_FAIL,
  payload: error,
})

// Mark as Seen
export const markNotificationAsSeen = id => ({
  type: MARK_NOTIFICATION_AS_SEEN,
  payload: id,
})

export const markNotificationAsSeenSuccess = id => ({
  type: MARK_NOTIFICATION_AS_SEEN_SUCCESS,
  payload: id,
})

export const markNotificationAsSeenFail = error => ({
  type: MARK_NOTIFICATION_AS_SEEN_FAIL,
  payload: error,
})

// Reset Flag
export const resetNotificationFlag = () => ({
  type: RESET_NOTIFICATION_FLAG,
})
